<div [class.ourAppEvent]=ourAppEvent>
    <our-app *ngIf="ourAppEvent"></our-app>
    <div class="pages">
        <router-outlet></router-outlet>
    </div>
</div>
<ng-template #template>
    <div class="modal-header">
        <h5 class="modal-title pull-left">Message important</h5>
        <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" [innerHtml]="alert">
    </div>
</ng-template>